import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettingsService } from '@core/services/app-settings.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    private router = inject(Router);
    projectCode = inject(AppSettingsService).projectCode;

    public goHomePage(): void {
        void this.router.navigate(['/']);
    }
}
